// Hash function was repurposed from here http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
export function hashErrorString(value) {
    let hash = 0, i, chr, len;
    if (value.length === 0) return hash;
    for (i = 0, len = value.length; i < len; i++) {
        chr = value.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = ((hash << 5) - hash) + chr;
        // eslint-disable-next-line no-bitwise
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export function ErrorOverrideService(
    $window,
    IS_PRODUCTION
) {
    if ($window.newrelic) {
        $window.newrelic.setErrorHandler(() => {
            // Tell newrelic to ignore every error
            // For more information, see:
            // https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/seterrorhandler/
            return true;
        });
    }

    return function logError(exception) {
        if (exception && exception.message && exception.message.includes('$compile:multidir')) {
            if (!IS_PRODUCTION) {
                console.debug('::: Handled [$compile:multidir] error!! Reloading page...');
            }
            // clear the directive naming collision with a full-page reload
            $window.location.reload();
        }

        // Throwing here will propagate the error to the Angular error handler.
        setTimeout(function() {
            throw exception;
        }, 0);
    };
}
ErrorOverrideService.$inject = [
    '$window',
    'IS_PRODUCTION'
];
